import { render, staticRenderFns } from "./BreadcrumbsLink.vue?vue&type=template&id=5dc5a520&scoped=true&lang=html&"
import script from "./BreadcrumbsLink.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsLink.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbsLink.vue?vue&type=style&index=0&id=5dc5a520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc5a520",
  null
  
)

export default component.exports